import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ListingOverviewWidget from '../components/ListingOverviewWidget';
import Listings from '../components/Listings';
import SearchFilter from '../components/SearchFilter';
import Layout from '../layout/Layout';
import { SetMeta } from '../utils/Helper/jsHelpers';

const VoetstootsTradeSale = () => {
    const { t } = useTranslation();
    const [resetFilter, setResetFilter] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <SetMeta
                title={t('voetstootsTradeSalePageTitle')}
                desc={t('voetstootsTradeSalePageDesc')}
                keywords={t('voetstootsTradeSalePageKeywords')}
            />
            <Layout showWhiteNavbar>
                <div className="listing-page">
                    <SearchFilter
                        resetFilter={resetFilter}
                        setResetFilter={setResetFilter}
                    />

                    <ListingOverviewWidget
                        title={t('voetstootsTradeSalePageTitle')}
                        description={t('voetstootsTradeSalePageDesc')}
                    />

                    <Listings
                        setResetFilter={setResetFilter}
                        voetstoots={true}
                    />
                </div>
            </Layout>
        </>
    );
};

export default VoetstootsTradeSale;
